import React, { useState } from 'react';
import { Col, Form, Row } from 'reactstrap';
import FormInput from '../../common/FormInput';
import FinanceCategoryModal, { FinanceCategoryData } from '../../modals/glAccounts/FinanceCategoryModal';
import GLAccountsModal, { GLAccountData } from '../../modals/glAccounts/GLAccountsModal';
import { useFormSection } from 'features/products/context/ProductDetailContext';

const GLAccountCodes: React.FC = () => {
  const { watch, setValue, getError } = useFormSection('glAccounts');
  
  const [isFinanceCategoryModalOpen, setIsFinanceCategoryModalOpen] = useState(false);
  const [isAssetAccountModalOpen, setIsAssetAccountModalOpen] = useState(false);
  const [isExpenseAccountModalOpen, setIsExpenseAccountModalOpen] = useState(false);
  const [isIncomeAccountModalOpen, setIsIncomeAccountModalOpen] = useState(false);

  const handleOpenFinanceCategoryModal = () => setIsFinanceCategoryModalOpen(true);
  const handleCloseFinanceCategoryModal = () => setIsFinanceCategoryModalOpen(false);
  const handleSelectFinanceCategory = (financeCategory: FinanceCategoryData) => {
    setValue('glFinanceCatName', financeCategory.name);
    setValue('glAssetAcntName', financeCategory.assetAccount);
    setValue('glExpAcntName', financeCategory.expenseAccount);
    setValue('glIncAcntName', financeCategory.incomeAccount);
    setIsFinanceCategoryModalOpen(false);
  };

  // Asset Account Modal Handlers
  const handleOpenAssetAccountModal = () => setIsAssetAccountModalOpen(true);
  const handleCloseAssetAccountModal = () => setIsAssetAccountModalOpen(false);
  const handleSelectAssetAccount = (glAccount: GLAccountData) => {
    setValue('glAssetAcntName', `${glAccount.glAccountNo} - ${glAccount.name}`);
    setIsAssetAccountModalOpen(false);
  };

  // Expense Account Modal Handlers
  const handleOpenExpenseAccountModal = () => setIsExpenseAccountModalOpen(true);
  const handleCloseExpenseAccountModal = () => setIsExpenseAccountModalOpen(false);
  const handleSelectExpenseAccount = (glAccount: GLAccountData) => {
    setValue('glExpAcntName', `${glAccount.glAccountNo} - ${glAccount.name}`);
    setIsExpenseAccountModalOpen(false);
  };

  // Income Account Modal Handlers
  const handleOpenIncomeAccountModal = () => setIsIncomeAccountModalOpen(true);
  const handleCloseIncomeAccountModal = () => setIsIncomeAccountModalOpen(false);
  const handleSelectIncomeAccount = (glAccount: GLAccountData) => {
    setValue('glIncAcntName', `${glAccount.glAccountNo} - ${glAccount.name}`);
    setIsIncomeAccountModalOpen(false);
  };

  return (
    <fieldset className="border rounded p-2">
      <legend className="float-none w-auto px-2 mb-0 text-body" style={{ fontSize: '0.9rem' }}>GL Account Codes</legend>
      <Form>
        <Row>
          <Col md={6}>
            <FormInput
              id="glFinanceCatName"
              label="Finance"
              value={watch('glFinanceCatName') || ''}
              onChange={(value: string) => setValue('glFinanceCatName', value)}
              hasSearchButton
              onSearchClick={handleOpenFinanceCategoryModal}
            />
            {/* Display validation error if any */}
            {getError('glFinanceCatName') && (
              <div className="text-danger small mt-1">
                {getError('glFinanceCatName')?.message}
              </div>
            )}
          </Col>
          <Col md={6}>
            <FormInput
              id="glAssetAcntName"
              label="Asset Account"
              value={watch('glAssetAcntName') || ''}
              onChange={(value: string) => setValue('glAssetAcntName', value)}
              hasSearchButton
              onSearchClick={handleOpenAssetAccountModal}
            />
            {/* Display validation error if any */}
            {getError('glAssetAcntName') && (
              <div className="text-danger small mt-1">
                {getError('glAssetAcntName')?.message}
              </div>
            )}
          </Col>
          <Col md={6}>
            <FormInput
              id="glExpAcntName"
              label="Expense"
              value={watch('glExpAcntName') || ''}
              onChange={(value: string) => setValue('glExpAcntName', value)}
              hasSearchButton
              onSearchClick={handleOpenExpenseAccountModal}
            />
            {/* Display validation error if any */}
            {getError('glExpAcntName') && (
              <div className="text-danger small mt-1">
                {getError('glExpAcntName')?.message}
              </div>
            )}
          </Col>
          <Col md={6}>
            <FormInput
              id="glIncAcntName"
              label="Income"
              value={watch('glIncAcntName') || ''}
              onChange={(value: string) => setValue('glIncAcntName', value)}
              hasSearchButton
              onSearchClick={handleOpenIncomeAccountModal}
            />
            {/* Display validation error if any */}
            {getError('glIncAcntName') && (
              <div className="text-danger small mt-1">
                {getError('glIncAcntName')?.message}
              </div>
            )}
          </Col>
        </Row>
      </Form>
      <FinanceCategoryModal
        isOpen={isFinanceCategoryModalOpen}
        onClose={handleCloseFinanceCategoryModal}
        onSelect={handleSelectFinanceCategory}
      />
      <GLAccountsModal
        isOpen={isAssetAccountModalOpen}
        onClose={handleCloseAssetAccountModal}
        onSelect={handleSelectAssetAccount}
        title="Asset Account"
      />
      <GLAccountsModal
        isOpen={isExpenseAccountModalOpen}
        onClose={handleCloseExpenseAccountModal}
        onSelect={handleSelectExpenseAccount}
        title="Expense Account"
      />
      <GLAccountsModal
        isOpen={isIncomeAccountModalOpen}
        onClose={handleCloseIncomeAccountModal}
        onSelect={handleSelectIncomeAccount}
        title="Income Account"
      />
    </fieldset>
  );
};

export default GLAccountCodes;
